<template>
  <div class="courseChooseDetail">
    <div class="deatilContent">
      <a-row type="flex" :gutter="[0,25]" justify="space-between">
        <a-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
          <div class="operateBox" style="background-color: #68AECB;font-size:32px ;" @click="goPath('/course/practiceWorkbook',0,'顺章练习')">
            <span class="span1">顺章练习 &nbsp;</span> <i class="iconfont" style="font-size: 32px;">&#xe626;</i>
          </div>
        </a-col>
        <a-col :xs="11" :sm="11" :md="11" :lg="6" :xl="6">
          <div class="operateBox" style="background-color: #92E8DB;font-size:24px ;flex-direction: column;" @click="toPath('/course/chapter','章节练习')">
            <span class="span1">章节练习 &nbsp;</span> <i class="iconfont" style="font-size: 24px;">&#xe626;</i>
          </div>
        </a-col>
        <a-col :xs="11" :sm="11" :md="11" :lg="6" :xl="6">
          <div class="operateBox" style="background-color: #515F91;font-size:24px ;flex-direction: column;" @click="goPath('/course/practiceWorkbook',1,'随机练习')">
            <span class="span1">随机练习 &nbsp;</span> <i class="iconfont" style="font-size: 24px;">&#xe626;</i>
          </div>
        </a-col>
      </a-row>
      <a-row type="flex" style="margin-top: 60px;" justify="space-between">
        <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="operateBox2" @click="goPageFn('/course/ErrorWorkbook','我的错题')">
            <div class="iconBox">
              <i class="iconfont">&#xe65d;</i>
            </div>
            <H3>我的错题</H3>
          </div>
        </a-col>
        <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="operateBox2" @click="goPageFn('/course/practiceWorkbook','我的收藏','SC')">
            <div class="iconBox">
              <i class="iconfont">&#xe6d9;</i>
            </div>
            <H3>我的收藏</H3>
          </div>
        </a-col>
        <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="operateBox2" @click="goPageFn('/course/noteList','我的笔记','BJ')">
            <div class="iconBox">
              <i class="iconfont">&#xe609;</i>
            </div>
            <H3>我的笔记</H3>
          </div>
        </a-col>
      </a-row>
    </div>

  </div>
</template>
<script>
import { mixinDevice } from "@/utils/mixin.js";
import { getAction, postAction } from '@/api/manage'
export default {
  name: 'courseChooseDetail',
  components: {},
  mixins: [mixinDevice],
  data() {
    return {
      routerInfo: {}
    }
  },
  created() {
    console.log('信息')
    this.routerInfo = this.$route.query
  },

  mounted() {
    console.log(this.$route.query)
    document.title = this.routerInfo.name
  },
  methods: {
    toPath(url,name){
      this.$router.push({path:url,query:{name:this.routerInfo.name + '/' + name,id:this.routerInfo.id,code:this.routerInfo.code,type:'DT',}})
    },
    goPath(url,status,name){
      this.$router.push({path:url,query:{name:this.routerInfo.name + '/' + name,id:this.routerInfo.id,random:status,pageType:this.$route.query.pageType}})
    },
    goPageFn(url,name,type=''){
      // if(type == 'BJ'){
      //   getAction('/teaching/comment/myCommentList?sourceType=4').then(res=>{})
      //   return
      // }
      this.$router.push({path:url,query:{name:this.routerInfo.name + '/' + name,type:type}})
    }
  }
}
</script>
<style lang='scss' scoped>
.courseChooseDetail {
  width: 100%;
  min-height: 100vh;
  background: #fff;

  .deatilContent {
    width: 100%;
    padding: 64px 25px;

    .operateBox {
      width: 100%;
      height: 118px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      color: #fff;
      border-radius: 14px;
      cursor: pointer;
    }

    .operateBox2 {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;

      .iconBox {
        width: 47px;
        height: 47px;
        background: linear-gradient(0deg, #82D0E1 0%, #5DD1D1 100%);
        box-shadow: 0px 0px 12px 0px rgba(25, 32, 68, 0.2);
        border-radius: 17px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;

        .iconfont {
          padding: 0;
          font-size: 22px;
        }

      }

      H3 {
        padding-top: 15px;
        font-size: 18px;
        color: #000000;
      }
    }
  }
}</style>
